module.exports = __webpack_public_path__ + "img/1-1.03ebd368.jpg";